import { render, staticRenderFns } from "./DossierRequest.vue?vue&type=template&id=77a97dd0&scoped=true&"
import script from "./DossierRequest.vue?vue&type=script&lang=js&"
export * from "./DossierRequest.vue?vue&type=script&lang=js&"
import style0 from "./DossierRequest.vue?vue&type=style&index=0&id=77a97dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a97dd0",
  null
  
)

export default component.exports